module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("BjZsD"))).then(() => parcelRequire('hEqeo'));